import styles from './Bar.module.css'

export type BarTone = 'brass' | 'brassDim' | 'win' | 'loss' | 'push' | 'muted'

export interface BarSegment {
  /* 0–100 */
  pct: number
  tone?: BarTone
  /* Data colour (wheel sector) overrides the tone. */
  color?: string
}

export interface BarProps {
  /* One or more segments laid left to right; sum ≤ 100. */
  segments: BarSegment[]
  thin?: boolean
  label?: string
}

/* Horizontal percentage bar. Widths are data, so the inline style lives here
   and nowhere else. */
export function Bar({ segments, thin, label }: BarProps) {
  return (
    <div className={[styles.track, thin && styles.thin].filter(Boolean).join(' ')} role={label ? 'img' : undefined} aria-label={label} title={label}>
      {segments.filter((s) => s.pct > 0).map((s, i) => (
        <span
          key={i}
          className={[styles.seg, !s.color && styles[s.tone ?? 'brass']].filter(Boolean).join(' ')}
          style={{ width: `${Math.min(100, Math.max(0, s.pct))}%`, ...(s.color ? { background: s.color } : {}) }}
        />
      ))}
    </div>
  )
}
